/**
 * Florastory 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Florastory 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: '#EAF8F0',
  // 按钮背景色
  btnPrimaryBg: '#EAF8F0',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #77ed7e 0%, #18cd8c 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/florastory/member_subscribe_bg.webp)',
} as const

/**
 * Florastory 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/florastory/member-bg.webp',
  // 用户背景图
  userBg: '/images/florastory/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/florastory/user-default.png',
  // VIP 图标
  memberVip: '/images/florastory/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/florastory/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  menuIcons: {
    transaction: '/images/florastory/member/icon-transaction.png',
    unlocked: '/images/florastory/member/icon-unlock.png',
    contactUs: '/images/florastory/member/icon-contact.png',
    setting: '/images/florastory/member/icon-setting.png',
  },
  texts: memberCommonConfig.texts,
}
